import axiosInstance from '../../../api/axios';

const withWorkspace = (workspaceId, extra = {}) => ({
  ...extra,
  ...(workspaceId ? { headers: { 'x-workspace-id': workspaceId } } : {}),
});

const analyticsApi = {
  async getDashboard(workspaceId, period) {
    const res = await axiosInstance.get(
      '/analytics/dashboard',
      withWorkspace(workspaceId, { params: { period } })
    );
    return res.data?.data;
  },

  /** Downloads an aggregated CSV. The server records the export with its purpose. */
  async exportSection(workspaceId, { section, period, purpose }) {
    const res = await axiosInstance.get(
      '/analytics/export',
      withWorkspace(workspaceId, { params: { section, period, purpose }, responseType: 'blob' })
    );
    const disposition = res.headers?.['content-disposition'] || '';
    const match = /filename="([^"]+)"/.exec(disposition);
    return { blob: res.data, filename: match ? match[1] : `analytics-${section}.csv` };
  },
};

/** Safe, user-facing error text (handles JSON errors returned as blobs). */
export async function getAnalyticsErrorMessage(error, fallback) {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed?.error || fallback;
    } catch {
      return fallback;
    }
  }
  return data?.error || fallback;
}

export default analyticsApi;
